import { createSelector } from 'reselect';

import { API_REQUEST_STATUS } from 'lib/constants';
import { getIsQuestInDemoMode, getIsDeepLink } from 'a/hub/selectors';

import { getShowRealTimeUsage } from './featureToggleSelectors';
import { getIsStaffLogin } from './persistStateSelectors';

export const getProductsUsage = (state) => {
  const { usage = {} } = state;

  if ([usage.reading.status, usage.lectura.status].some((status) => status !== API_REQUEST_STATUS.SUCCESS)) {
    return null;
  }

  return {
    reading: usage.reading.weeklyUsageTime,
    lectura: usage.lectura.weeklyUsageTime,
  };
};

export const getWeeklyUsageTarget = (state) => state.usage?.target?.weeklyTarget ?? null;

const getSelectedProductUsageState = (state) => {
  const { usage = {}, appSessionReducer = {} } = state;
  const { product: selectedProduct } = appSessionReducer;

  return usage[selectedProduct] || {};
};

export const getSelectedProductUsage = createSelector(
  [getSelectedProductUsageState, getWeeklyUsageTarget],
  (productUsage, weeklyTarget) => ({
    ...productUsage,
    celebrated: !!weeklyTarget && productUsage.lastShownUsageTime >= weeklyTarget,
  }),
);

export const getIsUsageFeatureAvailable = createSelector(
  [getShowRealTimeUsage, getIsStaffLogin, getIsQuestInDemoMode, getIsDeepLink],
  (showRealTimeUsage, isStaffLogin, isDemoMode, isDeepLink) =>
    showRealTimeUsage && !isStaffLogin && !isDemoMode && !isDeepLink,
);

export const getIsUsageDataAvailable = createSelector(
  [getIsUsageFeatureAvailable, getSelectedProductUsage],
  (isUsageFeatureAvailable, productUsage) =>
    isUsageFeatureAvailable && productUsage.status === API_REQUEST_STATUS.SUCCESS,
);
